<section class="login">
	<div class="login__title">
	</div>
	<div className="{nuevo ? 'nuevo login__container':'login__container'}" *ngIf="!mensaje && !mensajeValidacion"
		class="login__container">

		<div class="content">
			<div class="login__container__title">
				<h2>{{title}}</h2>
				<p>{{subTitle}}</p>
			</div>
			<div *ngIf="!recuperar && !passReset" class="login__container__form">
				<label>Cédula de identidad</label>
				<input [(ngModel)]="dpi" type="text" (keyup)="onlyDniChars($event)" maxlength="20"
					placeholder="Ingresa tu Cédula de identidad">
			</div>
			<div *ngIf="nuevo" class="login__container__form">
				<label>Nombres</label>
				<input [(ngModel)]="nombre" type="text" (keyup)="onlyLetter($event)" maxlength="30"
					placeholder="Ingresa tu Nombre">
			</div>
			<div *ngIf="nuevo" class="login__container__form">
				<label>Primer Apellido</label>
				<input [(ngModel)]="apePaterno" type="text" (keyup)="onlyLetter($event)" maxlength="30"
					placeholder="Ingresa tu Primer Apellido">
			</div>
			<div *ngIf="nuevo" class="login__container__form">
				<label>Segundo Apellido <span>(Opcional)</span></label>
				<input [(ngModel)]="apeMaterno" type="text" (keyup)="onlyLetter($event)" maxlength="30"
					placeholder="Ingresa tu Segundo Apellido">
			</div>
			<div *ngIf="nuevo" class="login__container__form">
				<label>Sexo</label>
				<select [(ngModel)]="sexo">
					<option value="M">Masculino</option>
					<option value="F">Femenino</option>
				</select>
			</div>
			<div *ngIf="nuevo" class="login__container__form">
				<label>Fecha de Nacimiento</label>
				<input [(ngModel)]="fecNacimiento" [max]="fechaAux" type="date"
					placeholder="Ingresa tu Fecha de Nacimiento">
			</div>
			<div *ngIf="nuevo" class="login__container__form">
				<label>Nacionalidad</label>
				<input [(ngModel)]="nacionalidad" maxlength="20" type="text" (keyup)="onlyLetterWhitoutSpace($event)"
					placeholder="Ingresa tu Nacionalidad">
			</div>
			<div *ngIf="nuevo" class="login__container__form">
				<label>Dirección</label>
				<input [(ngModel)]="direccion" maxlength="80" type="text" placeholder="Ingresa tu Dirección">
			</div>
			<div *ngIf="nuevo" class="login__container__form">
				<label>Número de Teléfono</label>
				<input [(ngModel)]="tel" type="text" maxlength="20" (keypress)="onlyNumber($event)"
					placeholder="Ingresa tu Teléfono">
			</div>
			<div *ngIf="!default && !passReset && !validaCorreo" class="login__container__form">
				<label>Correo Electrónico</label>
				<input [(ngModel)]="email" type="email" maxlength="50" placeholder="nombre.apellido@dominio.com" />
			</div>
			<div *ngIf="!default && !passReset && !validaCorreo" class="login__container__form">
				<label>Repetir correo Electrónico</label>
				<input [(ngModel)]="REemail" type="email" maxlength="50" placeholder="nombre.apellido@dominio.com" />
				<p *ngIf="!comprobReEmail() && REemail" class="alert red">Ambos email deben ser iguales</p>
			</div>
			<div *ngIf="(!recuperar || passReset) && !validaCorreo" class="login__container__form">
				<label class="d-flex">
					<div>Contraseña (Máximo 12 caracteres)</div>
					<a class="recovery" *ngIf="default" (click)="change(3)">¿Olvidaste tu contraseña?</a>
				</label>
				<input [(ngModel)]="password" id="password" #pass="ngModel" type="password" placeholder="Ingresa tu Contraseña"
					maxlength="12" (keyup.enter)="send(tipo)">
				<p class="alert red" *ngIf="this.password.length < 6 && pass.dirty">Debe tener al menos 6 caracteres
				</p>
			</div>
			<div *ngIf="nuevo || passReset" class="login__container__form">
				<label class="d-flex">
					<div>Repite Contraseña (Máximo 12 caracteres)</div>
				</label>
				<input [(ngModel)]="password2" type="password" placeholder="Repite tu Contraseña" maxlength="12">
			</div>
			<div *ngIf="nuevo" class="login__container__form politica-form">
				<div class="politica-check">
					<input type="checkbox" id="aceptaPolitica" [(ngModel)]="aceptaPoliticaTarjeta" name="aceptaPolitica">
					<label for="aceptaPolitica">Autorizo el registro y tratamiento de mis datos para <span class="politica-link" (click)="abrirPoliticaTarjeta($event)">esta finalidad</span>.</label>
				</div>
				<p *ngIf="!aceptaPoliticaTarjeta" class="politica-hint">Marca la casilla para poder crear tu cuenta. Toca "esta finalidad" para leer el detalle antes de aceptar.</p>
			</div>
			<!-- VALIDA CORREO -->
			<div *ngIf="validaCorreo && !mensajeValidacion" class="login__container__form">
				<label class="d-flex">
					<div>Por favor, haga click en el botón de abajo para validar su correo.</div>
					<!-- <button class="btn" (click)="send(tipo)">{{button}}</button> -->
				</label>
			</div>
			<!-- FIN VALIDA CORREO -->
			<div class="login__container__btn-group">
				<p *ngIf="errorMensaje" class="alert red">{{errorMensaje}}</p>
				<button *ngIf="!passReset && !loading && !validaCorreo" class="btn" [disabled]="nuevo && !aceptaPoliticaTarjeta" (click)="send(tipo)">{{button}}</button>
				<button *ngIf="passReset" class="btn" (click)="resetPassword()">{{button}}</button>
				<button *ngIf="validaCorreo" class="btn" (click)="send(4)">{{button}}</button>
				<div *ngIf="loading" class="lds-ring">
					<div></div>
					<div></div>
					<div></div>
					<div></div>
				</div>
				<a (click)="change(2)" *ngIf="default">Usuario Panamá, quiero registrarme</a>
				<a (click)="change(1)" *ngIf="nuevo">Ya tengo una cuenta, quiero iniciar sesión</a>
				<a (click)="change(1)" *ngIf="recuperar">Volver al comienzo</a>
			</div>
		</div>
	</div>
	<div *ngIf="mensaje" class="login__container">
		<div class="content">
			<div class="login__icon">
				<i class="material-icons">done</i>
				<p>Enviado correctamente</p>
				<button (click)="change(1)" class="btn">Volver</button>
			</div>
		</div>
	</div>
	<div *ngIf="mensajeValidacion" class="login__container">
		<div class="content">
			<div class="login__icon">
				<i class="material-icons">done</i>
				<p>Usuario validado correctamente</p>

				<button (click)="change(1)" class="btn">Volver</button>
			</div>
		</div>
	</div>
	<div class="modal" *ngIf="mostrarPoliticaTarjeta">
		<div class="modal__container">
			<div class="modal__header">
				<h2 class="modal__title">Registro de tarjeta</h2>
				<a (click)="cerrarPoliticaTarjeta()" class="btn-close"><i class="material-icons">close</i></a>
			</div>
			<div class="modal__body politica-modal__body">
				<p>Al continuar, autorizo el registro de mi tarjeta y la asociación de sus datos con mi información personal, con la finalidad de identificarla como una tarjeta registrada a mi nombre y facilitar la gestión de la tarjeta, incluyendo la recuperación del saldo en caso de pérdida, daño u otros inconvenientes.</p>
				<p>He sido informado sobre el tratamiento de mis datos personales y su finalidad, de conformidad con la Ley 81 de 2019 y su reglamentación.</p>
				<div class="politica-modal__warning">
					<p class="politica-modal__warning-title">Registro no completado</p>
					<p>No podremos completar el registro de tu tarjeta ni habilitar las funcionalidades asociadas, incluyendo su gestión y recuperación, cuando corresponda. Si deseas registrarla posteriormente, podrás volver a realizar el proceso.</p>
				</div>
			</div>
			<div class="politica-modal__actions">
				<button class="btn" (click)="cerrarPoliticaTarjeta()">Entendido</button>
			</div>
		</div>
	</div>
</section>
<div class="version">{{version}}</div>